import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import OrderFilters from "./OrderFilters";
import {
  ActionType, CHAINTYPES, orderFilterType, orderType, orgListItemType, reducerStoreType, ROLES, selectWalletType, storeType, userType,
  wallteType, accoutListType
} from "../../reducers/types";
import { Dispatch } from "redux";
import History from './History'
import Pagination from "../../components/Pagination";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  userList: userType[],
  walletList: wallteType[],
  storeList: storeType[],
  orgList: orgListItemType[],
  selectWallet: selectWalletType,
  filters: orderFilterType,
  orderList: orderType[],
  accoutList: accoutListType[],
  turnover: number,
  transactionNum: number,
  total: number,
  recordsPerPage: number,
  currentPage: number,
  chainType: CHAINTYPES,
  role: ROLES,
  currency: string
}
class Orders extends React.Component<IProps, {}> {
  handleFilterChange = (filters: orderFilterType) => {
    this.props.dispatch({ type: 'FILTERS_VALUE_CHANGE', payload: filters })
  }
  onConfirm = () => {
    this.props.dispatch({ type: 'GET_ORDERS', payload: { pageParams: { currentPage: 1 } } })
  }
  onClear = () => {
    this.props.dispatch({ type: 'CLEAR_FILTERS', payload: {} })
    this.props.dispatch({ type: 'GET_ORDERS', payload: { pageParams: { currentPage: 1 } } })
  }
  onPageChange = (page: number) => {
    // console.log(page)
    this.props.dispatch({ type: 'GET_ORDERS', payload: { pageParams: { currentPage: page } } })
  }
  onRecordsPerPageChange = (value: number) => {
    this.props.dispatch({ type: 'GET_ORDERS', payload: { pageParams: { recordsPerPage: value, currentPage: 1 } } })
  }
  onOrderExport = () => {
    this.props.dispatch({ type: 'GET_ORDERS', payload: { type: 'export' } })
  }
  public render() {
    console.log("!!!!!!!!!!!!!!!!!!!")
    console.log(this.props.userList)
    console.log(this.props.storeList)
    console.log(this.props.walletList)
    console.log("!!!!!!!!!!!!!!!!!!!")
    return (
      <div className="orders">
        <OrderFilters users={this.props.userList}
          walletList={this.props.walletList}
          accoutList={this.props.accoutList}
          storeList={this.props.storeList}
          orgList={this.props.orgList}
          selectWallet={this.props.selectWallet}
          filters={this.props.filters}
          handleFilterChange={this.handleFilterChange}
          onConfirm={this.onConfirm}
          onExport={this.onOrderExport}
          onClear={this.onClear}
          chainType={this.props.chainType}
          role={this.props.role}
        />
        <History list={this.props.orderList}
          users={this.props.userList}
          currency={this.props.currency}
          turnover={this.props.turnover}
          transactionNum={this.props.transactionNum}
          orgList={this.props.orgList}
          selectWallet={this.props.selectWallet}
        />
        <Pagination total={this.props.total}
          currentPage={this.props.currentPage}
          recordsPerPage={this.props.recordsPerPage}
          onPageChange={this.onPageChange}
          onRecordsPerPageChange={this.onRecordsPerPageChange} />
      </div>
    );
  }
}

export default connect((state: reducerStoreType) => {
  return {
    userList: state.users.userList,
    walletList: state.merchant.merchantInfo.walletList,
    accoutList: state.merchant.merchantInfo.accoutList,
    filters: state.orders.filters,
    storeList: state.merchant.storeList,
    orgList: state.merchant.merchantInfo.orgList,
    selectWallet: state.merchant.merchantInfo.selectWallet,
    orderList: state.orders.list,
    total: state.orders.total,
    recordsPerPage: state.orders.recordsPerPage,
    currentPage: state.orders.currentPage,
    turnover: state.orders.payAmt - state.orders.refundAmt,
    transactionNum: state.orders.payNum + state.orders.refundNum,
    chainType: state.merchant.merchantInfo.chainType,
    role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE,
    currency: state.merchant.merchantInfo.currency
  }
})(Orders)
